<template>
    <div class="row no-gutters justify-content-center">
        <div class="col-12">
            <div class="row no-gutters justify-content-space-evenly">
                <div class="col-6 col-md-5">
                    <div class="row justify-content-center mb-1">
                        <span class="font-weight-bold bet-text">TOP BET FOR TODAY:</span>
                    </div>
                    <div class="row justify-content-space-evenly align-items-center">
                        <div class="top-bet py-2 text-center clickable-item" v-on:click="onHorseClicked(magicTipsSection.topBet.raceNumber, magicTipsSection.topBet.horseNumber)">
                            <img class="bet-icon mr-1 mr-md-3" :src="getImage('star-icon')">
                            <span>RACE {{magicTipsSection.topBet.raceNumber}}: {{magicTipsSection.topBet.horseName}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md-5">
                    <div class="row justify-content-center mb-1">
                        <span class="font-weight-bold bet-text">VALUE BET FOR TODAY:</span>
                    </div>
                    <div class="row justify-content-space-evenly align-items-center">
                        <div class="value-bet py-2 text-center clickable-item" v-on:click="onHorseClicked(magicTipsSection.valueBet.raceNumber, magicTipsSection.valueBet.horseNumber)">
                            <img class="bet-icon mr-1 mr-md-3" :src="getImage('trophy-icon')">
                            <span>RACE {{magicTipsSection.valueBet.raceNumber}}: {{magicTipsSection.valueBet.horseName}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 my-4 mx-0 px-0">
            <div class="row no-gutters justify-content-space-evenly team-details-table">
                <div style="position: relative;" class="col-12">
                    <div id="team-details-table" class="table-responsive">
                        <table v-bind:class="{'table-sm': displaySmallTable}" class="table">
                            <thead class="thead-dark">
                            <tr class="table-subheader no-border-top">
                                <th colspan="6" class="text-center py-2">THE MAGIC TIPS SELECTIONS</th>
                            </tr>
                            <tr class="no-border-top magic-tips-selection-table-header">
                                <th class="race-number"></th>
                                <th class="py-1 selections"><img class="magic-tips-star-header" :src="getImage('star-icon')" v-for="index in 5" :key="index"></th>
                                <th class="py-1 selections"><img class="magic-tips-star-header" :src="getImage('star-icon')" v-for="index in 4" :key="index"></th>
                                <th class="py-1 selections"><img class="magic-tips-star-header" :src="getImage('star-icon')" v-for="index in 3" :key="index"></th>
                                <th class="py-1 selections"><img class="magic-tips-star-header" :src="getImage('star-icon')" v-for="index in 2" :key="index"></th>
                                <th class="py-1 selections"><img class="magic-tips-star-header" :src="getImage('star-icon')" v-for="index in 1" :key="index"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="hot-jockey-table-row-border" v-for="(raceSelection, index) in magicTipsSection.raceSelections" :key="index">
                                <td class="highlighted-table-cell font-weight-bold text-center black-border race-number clickable-item" v-on:click="onRaceClicked(raceSelection.raceNumber)">{{raceSelection.raceNumber}}</td>
                                <td class="black-border text-center selections clickable-item" v-for="(selection, index) in raceSelection.selections" :key="index"
                                    v-on:click="onHorseClicked(raceSelection.raceNumber, selection.horseNumber)">
                                    <span class="row no-gutters font-weight-bold justify-content-center horse-name-text">{{selection.horseName}}</span>
                                    <span class="row no-gutters justify-content-center jockey-name-text">{{selection.horseNumber}}&nbsp;&nbsp;{{selection.jockeyName}}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-11 col-md-5 mb-4 d-flex flex-column align-items-center">
            <span class="font-weight-bold bet-text">THE MAGIC TIPS BEST BET</span>
            <table class="col-11 text-center mr-2 table-border drop-shadow">
                <tr v-for="(bestBet, index) in magicTipsSection.bestBets" :key="index" class="best-bet">
                    <td class="px-2 flex-nowrap clickable-item" v-on:click="onRaceClicked(bestBet.raceNumber)">RACE {{bestBet.raceNumber}}:</td>
                    <td class="ml-2 flex-nowrap text-left clickable-item"
                        v-on:click="onHorseClicked(bestBet.raceNumber, bestBet.horseNumber)">{{bestBet.horseName}}({{bestBet.horseNumber}})</td>
                </tr>
            </table>
        </div>
        <div class="col-11 col-md-5 mb-4 d-flex flex-column align-items-center">
            <span class="font-weight-bold bet-text">THE MAGIC TIPS PICK 6</span>
            <table class="col-11 justify-content-center mr-2 table-border drop-shadow">
                <tr v-for="(pickSix, index) in magicTipsSection.pickSix.betTypeSelections" :key="index">
                    <td class="px-2 flex-nowrap black-border text-right p6-line-col">{{magicSelectionLines.pickSix[index]}}</td>
                    <td class="ml-2 flex-nowrap black-border text-center p6-data-col" v-for="(horseNumber, index) in pickSix.horseNumber" :key="index">{{horseNumber}}</td>
                </tr>
            </table>
        </div>
        <div class="col-11 col-md-5 mb-4 d-flex flex-column align-items-center">
            <span class="font-weight-bold bet-text">THE MAGIC TIPS PLACE ACCUMULATOR</span>
            <table class="col-11 justify-content-center mr-2 table-border drop-shadow">
                <tr v-for="(placeAccumulator, index) in magicTipsSection.placeAccumulator.betTypeSelections" :key="index">
                    <td class="px-2 flex-nowrap black-border text-right acc-line-col">{{magicSelectionLines.placeAccumulator[index]}}</td>
                    <td class="ml-2 flex-nowrap black-border text-center acc-data-col" v-for="(horseNumber, index) in placeAccumulator.horseNumber" :key="index">{{horseNumber}}</td>
                </tr>
            </table>
        </div>
        <div class="col-11 col-md-5 mb-4 d-flex flex-column align-items-center">
            <span class="font-weight-bold bet-text">THE MAGIC TIPS JACKPOT</span>
            <table class="col-11 justify-content-center mr-2 table-border drop-shadow">
                <tr v-for="(jackpot, index) in magicTipsSection.jackpot.betTypeSelections" :key="index">
                    <td class="px-2 flex-nowrap black-border text-right jackpot-line-col">{{magicSelectionLines.jackpot[index]}}</td>
                    <td class="ml-2 flex-nowrap black-border text-center jackpot-data-col" v-for="(horseNumber, index) in jackpot.horseNumber" :key="index">{{horseNumber}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import {MagicSelectionLines} from './configuration/magicSelectionLineMappings';
    import {RaceCardService} from "../services/raceCard.service";

    export default {
        name: "MagicTips",
        data: function () {
            return {
                magicTipsSection: {},
                magicSelectionLines: MagicSelectionLines,
                displaySmallTable: false
            };
        },
        computed: mapState(['selectedRaceStats', 'selectedRaceCardSummary']),
        methods: {
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            },
            onHorseClicked(raceNumber, horseNumber) {
                this.setIsLoading(true);
                this.setSelectedRaceCardHorseIndex(horseNumber);
                RaceCardService.getRace(this.selectedRaceCardSummary.raceInformation[raceNumber - 1].id, this.onRaceCardResponse.bind(this));
            },
            onRaceClicked(raceNumber) {
                this.setIsLoading(true);
                RaceCardService.getRace(this.selectedRaceCardSummary.raceInformation[raceNumber - 1].id, this.onRaceCardResponse.bind(this));
            },
            setTableState() {
                if (window.innerWidth < 1200) this.displaySmallTable = true;
            },
            onRaceCardResponse(response) {
                const selectedRace = response;
                this.setSelectedRaceCard(this.selectedRaceCardSummary);
                this.setSelectedRace(selectedRace);
                this.setIsLoading(false);
                this.$router.push({path: `/landing/racecard`});
            },
            ...mapMutations(['setIsLoading', 'setSelectedRaceCardHorseIndex', 'setSelectedRaceCard', 'setSelectedRace'])
        },
        created: function () {
            this.magicTipsSection = this.selectedRaceStats.magicTipsSection;
            this.setTableState();
        }
    }
</script>

<style scoped>
    .top-bet {
        background-color: #5E2A95;
        border-radius: 0.4rem;
        border: none;
        color: #FFFFFF;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
        width: 80%;
        font-size: 0.6rem;
    }

    .value-bet {
        background-color: #000000;
        border-radius: 0.4rem;
        border: none;
        color: #FFFFFF;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
        font-size: 0.6rem;
        width: 80%;
    }

    .bet-icon {
        width: 18px;
        height: 18px;
    }

    .magic-tips-star-header {
        width: 10px;
        height: 10px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .no-border-top {
        border-top-style: hidden;
    }

    .team-details-table {
        outline: solid 1px #000000;
    }

    .black-border {
        outline: solid 1px #000000;
    }

    .highlighted-table-cell {
        background-color: #f2f2f2;
    }

    tr {
        padding-top: 0.45rem;
        padding-bottom: 0.45rem;
    }

    .bet-text {
        font-size: 0.8rem;
        text-align: center;
    }

    .horse-name-text {
        font-size: 0.4rem;
    }

    .jockey-name-text {
        font-size: 0.4rem;
    }

    .table-border {
        border: solid 3px #000000;
    }

    .drop-shadow {
        box-shadow: 4px 5px 5px 0 rgba(0, 0, 0, 0.6);
    }

    .drop-shadow td {
        font-size: 0.8rem;
    }

    .best-bet td {
        line-height: 2rem;
    }

    .best-bet td:nth-child(1) {
        width: 50%;
    }

    .magic-tips-selection-table-header th:nth-child(2) {
        padding: 0.3rem 0 !important;
    }

    .best-bet td:nth-child(2) {
        width: 50%;
    }

    .race-numbers td {
        width: 8%;
    }

    .selections {
        width: 18%;
        padding: 0.5rem;
    }

    .p6-line-col {
        width: 22%;
    }

    .p6-data-col {
        width: 13%;
        padding: 0 0 !important;
    }

    .acc-line-col {
        width: 16%;
    }

    .acc-data-col {
        width: 12%;
        padding: 0 0 !important;
    }

    .jackpot-line-col {
        width: 25%;
    }

    .jackpot-data-col {
        width: 15%;
    }

    @media (min-width: 768px) {
        .drop-shadow td {
            font-size: 1.2rem;
        }

        .best-bet td:nth-child(1) {
            width: 43%;
        }

        .best-bet td:nth-child(2) {
            width: 57%;
        }

        .top-bet {
            width: 50%;
            font-size: 0.9rem;
        }

        .value-bet {
            width: 50%;
            font-size: 0.9rem;
        }

        .bet-icon {
            width: 28px;
            height: 28px;
        }

        .bet-text {
            font-size: 1.2rem;
        }

        .horse-name-text {
            font-size: 0.8rem;
        }

        .jockey-name-text {
            font-size: 0.8rem;
        }
        
        .tab-header {
            font-size: 1rem;
            padding: 0.5rem 0;
            font-weight: bold;
        }
    }
</style>